import React, { useState, useEffect } from 'react'
import NewSchooldetailStyle from './NewSchoolsOrganizationDetailPage.module.css'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import { BiSolidUpArrowCircle } from "react-icons/bi";
import logo from '../../../assets/images/demologo.png'
import BackBar from '../../components/BackBar/BackBar';
import { useParams, useNavigate } from 'react-router-dom';
import AdminFooter from '../../components/Footer/AdminFooter';
import Swal from "sweetalert2";
import axios from 'axios';

export default function NewSchoolsOrganizationDetailPage() {
  const [coordinator, setCoordinator] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [selectedProfilePic, setSelectedProfilePic] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [profilePreview, setProfilePreview] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  // console.log(id,'cid');
  useEffect(() => {

    const fetchCoordinatorData = async () => {
      try {

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_school_data.php?id=${id}`);
        const data = await response.json();

        if (data.success) {
          setCoordinator(data.coordinator);
        } else {
          setError(data.message);
        }
      } catch (err) {
        setError('Failed to fetch coordinator data.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchCoordinatorData();
  }, [id]);

  const handleSendContract = async (cordinatorId) => {
    try {
      //setSendingId(cordinatorId);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/send_contract.php`,
        { cordinator_id: cordinatorId },
        { headers: { 'Content-Type': 'application/json' } }
      );

      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: 'Contract Sent',
          text: 'The contract has been sent successfully.',
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: response.data.message || 'Failed to send contract.',
        });
      }
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Something went wrong while sending the contract.',
      });
    } finally {
      //setSendingId(null);
    }
  };

  const handleActivate = async (flag) => {


    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to activate this school?",
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, activate it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      // Make the API call to activate the school

      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_school_data.php?school_activate=${id}`);
      const data = await response.json();
      if (data.success) {
        await handleSendContract(id);
        Swal.fire({
          title: "Activation Successful!",
          text: "School activated successfully!.",
          icon: "success",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        }).then(() => {
          // Redirect after pop-up
          navigate(`/ActivatedSchoolsOrgPage`);
          //  window.location.reload();
        });
      }
      else {
        Swal.fire({
          title: "Failed!",
          text: "Failed to activate school!",
          icon: "error",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        })
      }
    } catch (error) {
      console.error('Error activating school:', error);
      alert('Failed to activate school. Please try again.');
    }
  };

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setCoordinator({ ...coordinator, [name]: value });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append('coordinator_id', id);
      formData.append('organization_name', coordinator.organization_name);
      formData.append('street_address', coordinator.st_address);
      formData.append('city', coordinator.city);
      formData.append('state', coordinator.state);
      formData.append('zipcode', coordinator.zipcode);
      formData.append('f_name', coordinator.f_name);
      formData.append('l_name', coordinator.l_name);
      formData.append('position', coordinator.position);
      formData.append('phone', coordinator.phone);
      formData.append('email', coordinator.email_id);

      // Add images if they are selected
      if (selectedLogo) {
        formData.append('organization_logo', selectedLogo);
      }
      if (selectedProfilePic) {
        formData.append('profile_pic', selectedProfilePic);
      }

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/update_cordinator_admin_data.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.success) {
        Swal.fire({
          title: "Success",
          text: "School information updated successfully!",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to update the coordinator's information.",
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error('Error updating coordinator data:', error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while updating the coordinator's information.",
        icon: "error",
        showConfirmButton: true,
      });
    }
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedLogo(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setLogoPreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleProfilePicChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedProfilePic(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setProfilePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageUpdate = async (type) => {
    try {
      const formData = new FormData();
      formData.append('coordinator_id', id);

      if (type === 'logo' && selectedLogo) {
        formData.append('organization_logo', selectedLogo);
      } else if (type === 'profile' && selectedProfilePic) {
        formData.append('profile_pic', selectedProfilePic);
      }

      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/update_cordinator_images.php`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.data.success) {
        Swal.fire({
          title: "Success",
          text: "Image updated successfully!",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Failed to update image.",
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error('Error updating image:', error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while updating the image.",
        icon: "error",
        showConfirmButton: true,
      });
    }
  };

  if (isLoading) return <div></div>;
  if (error) return <div>Error: {error}</div>;
  return (
    <>
      <AdminHeader />
      <div className={NewSchooldetailStyle.schoolsorganizationdetailpage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={`${NewSchooldetailStyle.schooldetailData} mb-4`}>
                <div className='row mb-3'>
                  <div className="col-sm-12 text-end">
                    <button className={`${NewSchooldetailStyle.activateBtn} btn btn-primary`} onClick={() => handleActivate(0)}>
                      <BiSolidUpArrowCircle /> Activate
                    </button>
                  </div>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-xl-4 col-xxl-4">
                      <h6>School/Organization Information</h6>
                      <div className={NewSchooldetailStyle.schoolboxData}>
                        <div className="mb-2 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-5 form-label`}>School/Organization Name</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${NewSchooldetailStyle.boxformControl} form-control`} name="organization_name" onChange={handleChange} value={coordinator.organization_name} placeholder="Demo Elementary School" />
                          </div>
                        </div>
                        <div className="mb-2 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-5 form-label`}>Street Address</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${NewSchooldetailStyle.boxformControl} form-control`} name="st_address" onChange={handleChange} value={coordinator.st_address} placeholder="12345 Demo Street" />
                          </div>
                        </div>
                        <div className="mb-2 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-5 form-label`}>City</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${NewSchooldetailStyle.boxformControl} form-control`} name="city" onChange={handleChange} value={coordinator.city} placeholder="Manassas" />
                          </div>
                        </div>
                        <div className="mb-2 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-5 form-label`}>State</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${NewSchooldetailStyle.boxformControl} form-control`} name="state" onChange={handleChange} value={coordinator.state} placeholder="Virginia" />
                          </div>
                        </div>
                        <div className="mb-3 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-5 form-label`}>Zip Code</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${NewSchooldetailStyle.boxformControl} form-control`} name="zipcode" onChange={handleChange} value={coordinator.zipcode} placeholder="20109" />
                          </div>
                        </div>
                        <div className="mb-3 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-5 form-label`}>School Logo</label>
                          <div className="col-sm-7">
                            <div className={`${NewSchooldetailStyle.boxwhole} align-items-center`}>
                              <div className={`${NewSchooldetailStyle.boximageCircle} rounded-circle mb-2`}>
                                <img
                                  src={logoPreview || `${process.env.REACT_APP_API_BASE_URL}authormeetapi/${coordinator.organization_logo}`}
                                  className='img-fluid' onClick={() => document.getElementById('logoInput').click()}
                                  style={{ cursor: 'pointer' }}
                                />
                                <input
                                  type="file"
                                  id="logoInput"
                                  style={{ display: 'none' }}
                                  accept="image/*"
                                  onChange={handleLogoChange}
                                />
                              </div>
                              <button type="submit" className={NewSchooldetailStyle.mainupdateButton} onClick={handleSubmit}>Update</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-xxl-4">
                      <h6>Coordinator Details</h6>
                      <div className={NewSchooldetailStyle.cordinatorboxData}>
                        <div className="mb-2 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-4 form-label`}>Name</label>
                          <div className="col-sm-8">
                            <input type="text" className={`${NewSchooldetailStyle.boxformControl} form-control`} name="profile_name" onChange={handleChange} value={`${coordinator.f_name} ${coordinator.l_name}`} placeholder="Mark Zuckerberg" />
                          </div>
                        </div>
                        <div className="mb-2 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-4 form-label`}>Position</label>
                          <div className="col-sm-8">
                            <input type="text" className={`${NewSchooldetailStyle.boxformControl} form-control`} name="position" onChange={handleChange} value={coordinator.position} placeholder="Librarian" />
                          </div>
                        </div>
                        <div className="mb-2 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-4 form-label`}>Phone Number</label>
                          <div className="col-sm-8">
                            <input type="text" className={`${NewSchooldetailStyle.boxformControl} form-control`} name="phone" onChange={handleChange} value={coordinator.phone} placeholder="123-456-7890" />
                          </div>
                        </div>
                        <div className="mb-3 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-4 form-label`}>Email</label>
                          <div className="col-sm-8">
                            <input type="email" className={`${NewSchooldetailStyle.boxformControl} form-control`} name="email_id" onChange={handleChange} value={coordinator.email_id} placeholder="email@email.com" />
                          </div>
                        </div>
                        <div className="mb-3 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-4 form-label`}>Profile Image</label>
                          <div className="col-sm-8">
                            <div className={`${NewSchooldetailStyle.boxwhole} align-items-center`}>
                              <div className={`${NewSchooldetailStyle.boximageCircle} rounded-circle mb-2`}>
                                <img
                                  src={profilePreview || `${process.env.REACT_APP_API_BASE_URL}authormeetapi/${coordinator.profile_pic}`}
                                  className='img-fluid' onClick={() => document.getElementById('profileInput').click()}
                                  style={{ cursor: 'pointer' }}
                                />
                                <input
                                  type="file"
                                  id="profileInput"
                                  style={{ display: 'none' }}
                                  accept="image/*"
                                  onChange={handleProfilePicChange}
                                />
                              </div>
                              <button type="submit" className={NewSchooldetailStyle.mainupdateButton} onClick={handleSubmit}>Update</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-4 col-xxl-4">
                      <h6>Password Information</h6>
                      <div className={NewSchooldetailStyle.passwordboxData}>
                        <div className="mb-2 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-5 form-label`}>Password</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${NewSchooldetailStyle.boxformControl} form-control`} name="password" onChange={handleChange} value={coordinator.password} readOnly />
                          </div>
                        </div>
                        <div className="mb-3 row align-items-center">
                          <label className={`${NewSchooldetailStyle.boxformLabel} col-sm-5 form-label`}>Confirm Password</label>
                          <div className="col-sm-7">
                            <input type="text" className={`${NewSchooldetailStyle.boxformControl} form-control`} value={coordinator.password} readOnly />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}

    